import React, { useState, useEffect } from 'react';
import { isIOS, isStandalone, getAppStoreLink, checkIfAppInstalled } from '../utils/universalLinks';
import './SmartBanner.css';

const SmartBanner = ({ currentPath = '/' }) => {
  const [showBanner, setShowBanner] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [appInstalled, setAppInstalled] = useState(false);

  useEffect(() => {
    const checkShouldShowBanner = async () => {
      // Don't show if not iOS, already dismissed, or in standalone mode
      if (!isIOS() || dismissed || isStandalone()) {
        return;
      }

      // Check if banner was dismissed in this session
      const sessionDismissed = sessionStorage.getItem('smartBannerDismissed');
      if (sessionDismissed) {
        return;
      }

      // Check if app is installed
      try {
        const installed = await checkIfAppInstalled(1500);
        setAppInstalled(installed);
        setShowBanner(true);
      } catch (error) {
        console.error('Error checking app installation:', error);
        // Show the banner anyway for download option
        setShowBanner(true);
      }
    };

    checkShouldShowBanner();
  }, [dismissed, currentPath]);

  const handleDismiss = () => {
    setDismissed(true);
    setShowBanner(false);
    sessionStorage.setItem('smartBannerDismissed', 'true');
  };

  const handleOpenApp = () => {
    if (appInstalled) {
      // App is installed, try to open it
      const appUrl = `mymenucart://${currentPath === '/' ? '' : currentPath.replace(/^\//, '')}`;
      window.location.href = appUrl;
    } else {
      // App not installed, go directly to App Store
      window.location.href = getAppStoreLink();
    }
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="smart-banner">
      <div className="smart-banner-container">
        <button 
          className="smart-banner-close"
          onClick={handleDismiss}
          aria-label="Close banner"
        >
          ×
        </button>
        
        <div className="smart-banner-icon">
          <img src="/myMenuCartIcon.png" alt="MyMenuCart" />
        </div>
        
        <div className="smart-banner-info">
          <div className="smart-banner-title">MyMenuCart</div>
          <div className="smart-banner-subtitle">Meal planning made easy</div>
          <div className="smart-banner-price">FREE - On the App Store</div>
        </div>
        
        <button 
          className="smart-banner-button"
          onClick={handleOpenApp}
        >
          {appInstalled ? 'OPEN' : 'VIEW'}
        </button>
      </div>
    </div>
  );
};

export default SmartBanner;
